module.exports = __webpack_public_path__ + "img/团队协作面板.0a517fd4.png";